document.addEventListener('DOMContentLoaded', function () {
  const header = document.querySelector('.page-header');

  if (header) {
    const navToggle = header.querySelector('.main-nav-toggle');

    if (window.pageYOffset > 0) {
      header.classList.add('scroll');
    }

    window.addEventListener('scroll', function () {
      if (window.pageYOffset > 0 && !header.classList.contains('scroll')) {
        header.classList.add('scroll');
      } else if (window.pageYOffset === 0 && header.classList.contains('scroll')) {
        header.classList.remove('scroll');
      }
    });

    const menuShow = function() {
      header.classList.add('opened');
    };

    const menuHide = function() {
      header.classList.remove('opened');
    };

    const navToggleHandler = function() {
      if (header.classList.contains('opened')) {
        menuHide();
      } else {
        menuShow();
      }
    };

    if (navToggle) {
      navToggle.addEventListener('click', navToggleHandler);
    }
  }

  //scroll

  let headerHeight = header.getBoundingClientRect().height;

  window.addEventListener('resize', () => {
    headerHeight = header.getBoundingClientRect().height;
  });

  $('.btn-scroll-to').click(function (e) {
    e.preventDefault();

    let elemId = $(this).attr('href');
    let scrollTo = $(elemId).offset().top - headerHeight + 10;

    if (header.classList.contains('opened')) {
      header.classList.remove('opened');
    }

    $('html, body').animate({
      scrollTop: scrollTo,
    }, 500);
  });

  // current-year
  const currentYear = document.querySelector('.current-year');
  if (currentYear) {
    const curYear = new Date().getFullYear();
    currentYear.textContent = curYear;
  }
});
